import { getCompressedAssetUrl } from 'lib/config/assetUrls';

/* Single point of change for the science section's CDN prefix. */
const SCIENCE_ASSET_BASE = '/web_v2/science';

export const scienceAsset = (path: string): string =>
  getCompressedAssetUrl(`${SCIENCE_ASSET_BASE}${path}`);

export const sciencePartnerLogo = (file: string): string =>
  scienceAsset(`/partners/${file}`);
